import { P2GCheckBox, P2GGrid, P2GText } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';
import { BasketSections } from '~/lib/types/enums';

export type props = {
  checked: boolean;
  onToggle: () => void;
};

export default function SameAsAbove({ checked, onToggle }: props) {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);

  return (
    <P2GGrid
      container
      direction="row"
      spacing={2}
      alignItems="center"
      wrap="nowrap"
      onClick={onToggle}
      dataTestId="address-based-on-account-container"
    >
      <P2GGrid item>
        <P2GCheckBox
          variant="primary"
          size="small"
          inputProps={{ checked: checked }}
          error={false}
          labelPlacement="end"
          label={null}
        />
      </P2GGrid>
      <P2GGrid item>
        <P2GText>
          <Trans
            i18nKey={`${BasketSections.ORIGIN}_ADDRESS_BASEDONACCOUNT_MESSAGE`.toUpperCase()}
            t={t}
            defaults="Use the same details as above."
            components={[]}
          />
        </P2GText>
      </P2GGrid>
    </P2GGrid>
  );
}
